// client/src/components/auth/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Тонкая обёртка для защиты роутов.
 *
 * Проверяет ТОЛЬКО:
 *   - authChecked (сессия проверена?)
 *   - isAuthenticated (пользователь залогинен?)
 *
 * НЕ проверяет роли/ресурсы — это делают сами страницы через useAccessControl.
 *
 * Такой подход исключает ошибку React #300, которая возникала из-за
 * сложных проверок внутри ProtectedRoute с ранними return <Navigate>.
 */
export default function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const authChecked = useSelector((state) => state.auth?.authChecked);

  // 1. Сессия ещё проверяется
  if (!authChecked) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Проверка сессии...
        </Typography>
      </Box>
    );
  }

  // 2. Не залогинен — на главную
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // 3. Всё ок
  return children;
}
